import { UseQueryResult, useQuery } from 'react-query';

import { getTokenWithType } from './useAuth';

import { getStateProvince } from '../utils/urls';

import { ErrorModal } from 'types/modalTypes';

async function fetchStateProvince(): Promise<APIResult> {
  const response = await fetch(getStateProvince, {
    method: 'GET',
    headers: {
      Authorization: getTokenWithType(),
    },
  });
  return response.json();
}

type TError = ErrorModal;

type APIResult = {
  IsSuccess: boolean;
  StatusCode: number;
  Data: Array<{
    Id: number;
    CountryId: number;
    Abbreviation: string;
    Country?: string;
    Name: string;
  }>;
};

type TResult = Array<{
  id: number;
  name: string;
}>;

function useGetStateProvince(): UseQueryResult<TResult, TError> {
  return useQuery(
    'get_state_province',
    async () => {
      const fetchResponse = await fetchStateProvince();
      const result = fetchResponse?.Data?.map(item => ({
        id: item.Id,
        name: item.Name,
      }));
      return result;
    },
    {
      staleTime: 60 * 1000,
      refetchOnWindowFocus: false,
    },
  );
}

export { useGetStateProvince };
